export default [
  { country: 'South Korea', code: 82 },
  { country: 'Cambodia', code: 855 },
  { country: 'Australia', code: 61 },
  { country: 'Belgium', code: 32 },
  { country: 'Brazil', code: 55 },
  { country: 'China', code: 86 },
  { country: 'France', code: 33 },
  { country: 'Finland', code: 358 },
  { country: 'Greece', code: 30 },
  { country: 'Germany', code: 49 },
  { country: 'Hong kong', code: 852 },
  { country: 'Indonesia', code: 62 },
  { country: 'Iran', code: 98 },
  { country: 'Chile', code: 56 },
  { country: 'Cuba', code: 53 },
  { country: 'Colombia', code: 57 },
  { country: 'Czech Republic', code: 420 },
  { country: 'Denmark', code: 45 },
  { country: 'Egypt', code: 20 },
  { country: 'Ecuador', code: 593 },
  { country: 'Fiji', code: 679 },
  { country: 'Ghana', code: 233 },
  { country: 'India', code: 91 },
  { country: 'Iraq', code: 964 },
  { country: 'Japan', code: 81 },
  { country: 'Libya', code: 218 },
  { country: 'Malaysia', code: 60 },
  { country: 'Monaco', code: 377 },
  { country: 'Morocco', code: 212 },
  { country: 'Mozambique', code: 258 },
  { country: 'Netherlands', code: 31 },
  { country: 'New Zealand', code: 64 },
  { country: 'Norway', code: 47 },
  { country: 'Paraguay', code: 595 },
  { country: 'Peru', code: 51 },
  { country: 'Philippines', code: 63 },
  { country: 'Poland', code: 48 },
  { country: 'Qatar', code: 974 },
  { country: 'Romania', code: 40 },
  { country: 'Russia', code: 7 },
  { country: 'Senegal', code: 221 },
  { country: 'Singapore', code: 65 },
  { country: 'Solomon Islands', code: 677 },
  { country: 'South Africa', code: 27 },
  { country: 'South Spain', code: 34 },
  { country: 'Sweden', code: 46 },
  { country: 'Swaziland', code: 268 },
  { country: 'Taiwan', code: 886 },
  { country: 'Tanzania', code: 255 },
  { country: 'Thailand', code: 66 },
  { country: 'Turkey', code: 90 },
  { country: 'Ukraine', code: 380 },
  { country: 'United Kingdom', code: 44 },
  { country: 'United States', code: 1 },
  { country: 'Uruguay', code: 598 },
  { country: 'Uzbekistan', code: 998 },
  { country: 'Vietnam', code: 84 },
  { country: 'Yemen', code: 967 },
  { country: 'Zambia', code: 260 },
  { country: 'Zimbabwe', code: 263 }
]
